export default {"src":"/_next/static/media/Void.daf76c3b.svg","height":835,"width":798,"blurWidth":0,"blurHeight":0};